import {styled} from "@reside/ui";

export const ReportingRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;
